export const reportFields = {
  gridJourneyWork: [
    "start",
    "startLocal",
    "end",
    "endLocal",
    "distanceKm",
    "travelTime",
    "restTime",
    "avgSpeedKmH",
    "maxSpeed",
    "driver",
    "plate",
  ],
  gridTravelledDistance: [
    "distance",
    "startProcessingDate",
    "startLocation",
    "endProcessingDate",
    "endLocation",
  ],
  gridVehicleActivities: [
    "dayOfWeek",
    "generationDate",
    "km",
    "ignitionOn",
    "engineTime",
    "ignitionOff",
    "filteredSpeedCount",
    "unfilteredSpeedCount",
  ],
  gridVehiclePositions: [
    "generationDate",
    "statusDescription",
    "ignition",
    "event",
    "speed",
    "location",
  ],
  gridPeriodVisits: [
    "licensePlate",
    "startDate",
    "duration",
    "eventType",
    "location",
  ],
  gridVisitAmount: [
    "location", 
    "startDate",
    "duration",
    "eventType",
    "licensePlate",
  ],
  gridSpeedControl: [
    "plate",
    "date",
    "speed",
    "location",
    ],
  gridProtocols: [
    "id",
    "plate",
    "status",
    "alert",
    "dateTimeOpen",
    "dateTimeService",
    "dateTimeClose",
    "attendant",
  ],
  gridSystemLogs: [
    "date",
    "operationType",
    "userName",
    "loggedUserName",
    "logDescription",
  ],
};
